import { createSlice } from "@reduxjs/toolkit";

// Defino valor inicial para el estado de mi slice
const initialState = {
  data: [],
};

// creo el slice con toda su configuración y sus acciones
const jobsListSlice = createSlice({
  name: "jobsListSlice",
  initialState,
  reducers: {
    setJobsList: (state, action) => {
      state.data = action.payload;
    },
  },
});

// Expongo las funcionalidades
export const { setJobsList } = jobsListSlice.actions;

export default jobsListSlice.reducer;
